import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import ImageOverlay from './ImageOverlay';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginTop: 10,
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  title: {
    color: theme.palette.primary.white,
    textAlign: 'center',
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
}));

/**
 * The example data is structured as follows:
 *
 * import image from 'path/to/image.jpg';
 * [etc...]
 *
 * const itemData = [
 *   {
 *     img: image,
 *     title: 'Image',
 *     author: 'author',
 *   },
 *   {
 *     [etc...]
 *   },
 * ];
 */
export default function SingleLineImageList({ itemData }) {
  const classes = useStyles();
  const [overlaySrc, setOverlaySrc] = useState(null);

  return (
    <div className={classes.root}>
      <ImageList className={classes.imageList} cols={2}>
        {itemData &&
          itemData.map((item) => (
            <ImageListItem
              style={{ height: 300, cursor: 'pointer' }}
              key={item.resource_id}
              onClick={() => setOverlaySrc(item.url_image)}
            >
              <img
                style={{ height: 300 }}
                src={item.url_image}
                alt={item.title}
              />
              <ImageListItemBar
                title="Service Image"
                classes={{
                  root: classes.titleBar,
                  title: classes.title,
                }}
              />
            </ImageListItem>
          ))}
      </ImageList>
      <ImageOverlay
        open={Boolean(overlaySrc)}
        src={overlaySrc}
        alt="Service Image"
        onClose={() => setOverlaySrc(null)}
      />
    </div>
  );
}

SingleLineImageList.propTypes = {
  itemData: PropTypes.array,
};
